import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { RegistrationFlowOrchestration } from '../../types/apiConfig';

const initialState: RegistrationFlowOrchestration[] = [];

const registrationFlowOrchestrationSlice = createSlice({
  name: 'registrationFlowOrchestration',
  initialState,
  reducers: {
    loadRegistrationFlowOrchestration: (
      state,
      action: PayloadAction<RegistrationFlowOrchestration[]>
    ) => {
      return action.payload;
    },
  },
});

export const registrationFlowOrchestrationSelector = (state: RootState) =>
  state.registrationFlowOrchestration;
export const { loadRegistrationFlowOrchestration } = registrationFlowOrchestrationSlice.actions;
export default registrationFlowOrchestrationSlice.reducer;
